import React from 'react'
import classNames from 'classnames'

import Icon from '../Icon'

import type { IconName } from '../Icon'
import type { PropsWithChildren } from 'react'

import styles from './styles.module.scss'

type Props = PropsWithChildren<{
  icon: IconName
  isLink?: boolean
  onClick: () => void
  dataTestid?: string
  /** highlighted as the currently shown section (two-pane settings sidebar) */
  active?: boolean
}>

export default function SettingsIconButton({
  children,
  icon,
  isLink = false,
  onClick,
  dataTestid,
  active,
}: Props) {
  return (
    <button
      type='button'
      className={classNames(styles.settingsIconButton, {
        [styles.active]: active,
      })}
      onClick={onClick}
      data-testid={dataTestid}
      aria-current={active || undefined}
    >
      <Icon icon={icon} />
      <span className={styles.settingsIconButtonLabel}>{children}</span>
      {isLink && <Icon icon='open_in_new' />}
    </button>
  )
}
